import React from 'react';

import useScrollToTop from './useScrollToTop';
import './ScrollToTop.scss';

const ScrollToTop: React.FC = ({ children }) => {
    useScrollToTop();

    return <div styleName="container">{children}</div>;
};

export default ScrollToTop;
